var map = {
	"./LogoUrdoer.png": 10682,
	"./breadcrumb/banner_bg.png": 34214,
	"./erp-home/background.png": 86438,
	"./erp-home/banner_shap.png": 47679,
	"./erp-home/cloud_01.png": 15413,
	"./erp-home/shape.png": 68583,
	"./error_bg.png": 36964,
	"./home-chat/432-ai.png": 10873,
	"./home-chat/book.png": 2308,
	"./home-chat/box.png": 59976,
	"./home-chat/croppedchat.gif": 61483,
	"./home-chat/dashboard.png": 68260,
	"./home-chat/dot.png": 82894,
	"./home-chat/get_started_bg.png": 73075,
	"./home-chat/googleMeet.png": 70083,
	"./home-chat/liveChat.gif": 62220,
	"./home-chat/login.png": 91636,
	"./home-chat/mobile.png": 28581,
	"./home-chat/triangle.png": 21199,
	"./home-chat/video_icon.png": 30860,
	"./home-event/dot.png": 43346,
	"./home-event/leader.png": 87556,
	"./home-event/price_shap.png": 87051,
	"./home-security/rocket.png": 73899,
	"./home-security/shap.png": 12189,
	"./home-security/sheld_bg.png": 68507,
	"./home-security/shield.png": 11280,
	"./home-software/down_bg.png": 84612,
	"./home-tracking/activity_icon.png": 48679,
	"./home-tracking/cta.png": 91776,
	"./home-tracking/cta_pattern_bg.jpg": 73025,
	"./home2/action_bg.png": 68734,
	"./home3/logo_01.png": 59858,
	"./home3/logo_02.png": 66921,
	"./home3/logo_03.png": 95744,
	"./home3/logo_04.png": 47071,
	"./home3/logo_05.png": 50742,
	"./home4/action_shap.png": 75875,
	"./home4/banner_bg.png": 5592,
	"./home4/divider.png": 71139,
	"./home4/dot.png": 60937,
	"./home4/review1.jpeg": 31262,
	"./home4/review2.jpeg": 42571,
	"./home4/review3.jpeg": 9828,
	"./home4/review4.jpeg": 17425,
	"./home4/review5.jpeg": 14474,
	"./home5/featured_bg_shape.png": 4575,
	"./home5/icon_shape.png": 86188,
	"./home5/shap_tecture.png": 59672,
	"./home7/banner.png": 67765,
	"./home8/dot.png": 57317,
	"./home9/footer.png": 49576,
	"./home9/icon_shape_two.png": 57075,
	"./home9/shape-footer.png": 81236,
	"./home9/shape.png": 7754,
	"./home9/shape_two.png": 69401,
	"./home9/triangle_bottom.png": 3399,
	"./home9/triangle_top.png": 60397,
	"./logo1.png": 32480,
	"./new-home/back_bg.png": 45986,
	"./new/01.png": 84052,
	"./new/cup.png": 55377,
	"./new/error.png": 71119,
	"./new/feedback_shap.png": 49811,
	"./new/leaf.png": 14857,
	"./new/new_shape.png": 88853,
	"./new/price_bg.png": 83902,
	"./new/shape_bg.png": 17362,
	"./new/startup_banner_bg.png": 92359,
	"./new/startup_shap.png": 10453,
	"./new/tab_shape_bg.png": 68698,
	"./new/testimonial_bg.png": 77748,
	"./new/testimonial_bg_shap.png": 34271,
	"./new/testimonial_bg_two.png": 64191,
	"./pos/b_dashboard.png": 31018,
	"./pos/fotter_shap.png": 76996,
	"./pos/pattern_01.png": 34661,
	"./pos/pattern_02.png": 32238,
	"./pos/shape.png": 32446,
	"./pos/shape_bg.png": 40874,
	"./pos/wave_two.png": 58569,
	"./saas/map.png": 77583,
	"./saurav ranjna mooc.pdf": 82622,
	"./seo/bike.png": 53521,
	"./seo/car.png": 26098,
	"./seo/cloud.png": 93363,
	"./seo/cloud_bg.png": 21681,
	"./seo/footer_bg.png": 23905,
	"./seo/icon1.png": 50992,
	"./seo/icon2.png": 22283,
	"./seo/icon3.png": 1154,
	"./seo/icon4.png": 5405,
	"./seo/icon5.png": 72372,
	"./seo/icons8-experiments-100.png": 76457,
	"./seo/icons8-homework-64.png": 85594,
	"./seo/icons8-lab-100.png": 88936,
	"./seo/icons8-lab-64.png": 74939,
	"./seo/icons8-laboratory-100.png": 87034,
	"./seo/icons8-live-64.png": 85546,
	"./seo/icons8-live-streaming-100.png": 72620,
	"./seo/icons8-live-streaming-64.png": 97159,
	"./seo/icons8-notebook-100.png": 81746,
	"./seo/icons8-notebook-58.png": 7012,
	"./seo/icons8-notebook-60.png": 99041,
	"./seo/icons8-online-class-100.png": 12643,
	"./seo/icons8-online-class-58.png": 27679,
	"./seo/icons8-project-100.png": 58014,
	"./seo/icons8-project-58.png": 30304,
	"./seo/icons8-test-tube-rack-48.png": 62873,
	"./seo/icons8-video-player-64.png": 68007,
	"./seo/icons8-writing-100 (1).png": 26887,
	"./seo/icons8-writing-64.png": 74496,
	"./seo/lab2.png": 76379,
	"./seo/logo_04.png": 99292,
	"./seo/shap.png": 68144,
	"./seo/testin1.png": 11398,
	"./seo/testin2.png": 52637,
	"./seo/triangle_one.png": 39375,
	"./seo/triangle_three.png": 77027,
	"./seo/triangle_two.png": 34925,
	"./seo/writing-100.png": 76590,
	"./tutorlancer.png": 10059,
	"./urDoer1.png": 9938,
	"./urDoer2.png": 58121,
	"./urDoer3.png": 33920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87958;